<template>
    <div class="max-w-4xl mx-auto p-4">
        <h1 class="text-2xl font-semibold text-theme-base mb-2">
            Filtros del catálogo
        </h1>
        <p class="text-sm text-theme-muted mb-6">
            Configura los filtros que aparecen en la página general de productos
            de tu catálogo público.
        </p>

        <div class="flex flex-wrap mt-4">
            <filters-manage
                v-model="form.filters"
                :enabled="canUpdateFiltersSettings"
            >
                <template slot="action">
                    <app-button :loading="isLoading" class="mt-4" @click="save">
                        Actualizar
                    </app-button>
                </template>
            </filters-manage>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { OperationsModes } from "@/common/fields/operations-modes";

import AppButton from "@/components/utils/AppButton.vue";
import FiltersManage from "@/components/utils/FiltersManage.vue";

export default {
    name: "SettingsFiltersPage",
    components: { AppButton, FiltersManage },
    layout: "app",
    data: () => ({
        isLoading: false,
        form: {
            filters: []
        }
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"]),
        isMultiTenant() {
            return this.$operationMode === OperationsModes.multiTenant;
        },
        canUpdateFiltersSettings() {
            return this.$ability.hasPermission("tenant:UpdateFiltersSettings");
        }
    },
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (
            !(await verifyPagePermission(
                "tenant:GetFiltersSettings",
                "/app/settings"
            ))
        )
            return;
        if (this.isMultiTenant) {
            await this.$swal.fire({
                background: this.backgroundColor,
                type: "info",
                title: "No disponible",
                text: "Los filtros del catálogo no aplican en modo multi-tienda.",
                timer: 5000
            });
            this.$router.push("/app/settings");
            return;
        }
        await this.loadSettings();
    },
    methods: {
        ...mapActions("tenants", [
            "getTenantFiltersSettings",
            "updateTenantFiltersSettings"
        ]),
        async loadSettings() {
            this.$loading.show();
            try {
                const data = await this.getTenantFiltersSettings();
                this.form.filters = Array.isArray(data.filters)
                    ? [...data.filters]
                    : [];
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.$sound.play("error");
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async save() {
            this.isLoading = true;
            try {
                await this.updateTenantFiltersSettings({
                    filters: this.form.filters
                });
                this.$toast.success({
                    title: "Configuración actualizada",
                    text: "Los filtros del catálogo han sido guardados."
                });
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.$sound.play("error");
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        }
    }
};
</script>
